<div >
  <h6 class="mb-3 text-muted"><b>Fee Payment</b></h6>
  <!--<div class="row">
    <div class="col-md-12 col-lg-12 mb-3 align-items-stretch ">  
      <span class="text-blue">You will be <b>sign out</b> after adding organization. The details will be available in profile section.</span>
    </div>
  </div>-->
  <form [formGroup]="searchForm"> 
  <div class="row">
     
      <div class="col-md-12 col-lg-4 mb-4 align-items-stretch ">
        <div class="form-group">
          <label for="studentAdm" class="text-gray-bold required">Student</label>
          <select class="form-control rounded-0" id="studentAdm" formControlName="studentAdm">
            <option [value]="null" [selected]="true" disabled>Select Student</option>
            <option class='option' *ngFor='let student of studentList' [ngValue]="student.admNumber">{{student.studentName}}</option>
          </select>               
        </div>
      </div>
      <div class="col-md-12 col-lg-4 mb-4 align-items-stretch ">
        <div class="form-group">
          <label for="session" class="text-gray-bold required">Academic Year</label>
          <select class="form-control rounded-0" id="session" formControlName="academicYear">
            <option [value]="null" [selected]="true" disabled>Select Session</option>
            <option class='option' *ngFor='let session of sessionList' [ngValue]="session">{{session}}</option>
          </select>               
        </div>
      </div>
      <div class="col-md-2">
        <button *ngIf="!searchForm.invalid" type="button" class="btn-success p-1" (click)="getFeeList()">Fetch Fees</button>
        <button *ngIf="searchForm.invalid" type="button" class="btn-custom-disable p-1" [disabled]="searchForm.invalid" (click)="getFeeList()">Fetch Fees</button>
      </div>    
  </div> <!--row ends-->
  </form>
  <div class="row">
    <div class="col-md-12 col-lg-12 mb-4 align-items-stretch ">             
      <div class="card border-0 rounded h-100 ">                             
        <div class="card-title mb-0 p-1 d-flex">Fee Details&nbsp;&nbsp;
          <a class="btn p-0 " *ngIf="!showRefreshSpinner" (click)="refreshFeeList()">
            <i class="fa fa-refresh" style="color: green"></i>
          </a>
          <a class="btn p-0 " *ngIf="showRefreshSpinner">
            <i class="fa fa-refresh fa-spin" style="color: green"></i>
          </a>
        </div>          
        <div class="card-body p-2 mb-2">
          <div class="table-responsive"  id="print-section">                  
            <!--<table class="table table-hover table-fit">-->
            <table class="table table-hover">
              <thead class="thead-dark">
                <tr> 
                  <!--<th><input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()"></th>-->
                  <th>Session</th>
                  <th>Group</th>
                  <th>Type</th>
                  <th>Generated Amount</th>
                  <th>Discount</th>
                  <th>Payble Amount</th>
                  <th>Paid Amount</th>
                  <th>Balance Amount</th>
                  <th>Action</th>  
                </tr>
              </thead>
              <tbody> <!--fileList-->
                <tr style="cursor:pointer;" *ngFor="let fee of feeList">
                  <!--<td>
                    <input type="checkbox" [(ngModel)]="role.selected">
                  </td>-->
                  <td>{{fee.session}}</td>
                  <td>{{fee.feeGroup}}</td>
                  <td>{{fee.feeType}}</td>
                  <td>{{fee.generatedAmount}}</td>
                  <td>{{fee.discount}}</td>
                  <td>{{fee.paybleAmount}}</td>
                  <td>{{fee.paidAmount}}</td>
                  <td>{{fee.balanceAmount}}</td>
                  <td>   
                    <button  class="btn-custom p-1" (click)="payNowModal(fee.id, fee.balanceAmount)">Pay Online</button>                 
                    &nbsp;&nbsp;      
                    <button  class="btn-custom p-1" (click)="getPaymentHistoryModal(fee.id)">Payment History</button>                 
                    &nbsp;&nbsp;
                    <a data-bs-toggle="dropdown" class="btn ml-auto p-0 text-danger" > 
                        <i class="fas fa-ellipsis-h"></i> 
                    </a>
                  </td> 
                </tr>      
              </tbody>
            </table>
          </div>
        </div>
      </div><!-- card-->
    </div><!--col-->
  </div><!-- row ends-->
</div>